import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;

import React from 'react';
import { getStateStyles } from "../../context-menu/contextMenuItemStateStyles";
import { focusOutlineColors, getRem } from "../../core";
import { IconCheck } from "../../icons";
import { ListItemPrimaryText, ListItemText, ListItem, ListItemGraphic, ListItemCheckbox } from "../../list";
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledIconCheck = styled(IconCheck)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), function (_ref) {
  var theme = _ref.theme;
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    align-self: flex-start;\n    fill: ", ";\n    flex-shrink: 0;\n    height: 100%;\n    padding-left: ", ";\n    width: ", ";\n  "])), theme.color.primary[500].value, theme.size.spacing.medium.value, getRem(18));
});
var StyledListItemPrimaryText = styled(ListItemPrimaryText)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (_ref2) {
  var isDisabled = _ref2.isDisabled,
      theme = _ref2.theme;
  return isDisabled && theme.color.text.light.disabled.value;
});
var StyledListItemCheckbox = styled(ListItemCheckbox)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  margin-left: ", ";\n  padding-right: 0;\n"])), getRem(2));
var StyledListItem = styled(ListItem)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  overflow: visible;\n  ", "\n\n  ", "\n\n  ", "\n"])), function (_ref3) {
  var isSelected = _ref3.isSelected,
      showCheckbox = _ref3.showCheckbox;
  return css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    ", ";\n    ", ";\n  "])), !showCheckbox && "padding-right: ".concat(isSelected ? getRem(6) : getRem(38)), showCheckbox ? getStateStyles(false)["default"] : getStateStyles(isSelected)["default"]);
}, function (_ref4) {
  var isDisabled = _ref4.isDisabled,
      isKeyboardFocused = _ref4.isKeyboardFocused,
      isSelected = _ref4.isSelected,
      showCheckbox = _ref4.showCheckbox,
      theme = _ref4.theme;
  return !isDisabled && css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n      cursor: pointer;\n      &:hover {\n        ", "::after {\n          background-color: ", ";\n        }\n        ", "\n      }\n\n      &:focus {\n        ", "::after {\n          background-color: ", ";\n          ", "\n        }\n        ", "\n      }\n\n      &:active {\n        ", "::after {\n          background-color: ", ";\n          box-shadow: none;\n        }\n        ", "\n      }\n    "])),
  /* sc-selector */
  ListItemCheckbox, isSelected ? theme.color.state.primary.hover.value : theme.color.state["default"].hover.value, !showCheckbox && getStateStyles(isSelected).hover,
  /* sc-selector */
  ListItemCheckbox, isSelected ? theme.color.state.primary.focus.value : theme.color.state["default"].focus.value, isKeyboardFocused && css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n            box-shadow: 0 0 0 4px\n              ", ";\n          "])), isSelected ? focusOutlineColors.getPrimary(theme) : focusOutlineColors.getDark(theme)), !showCheckbox && isKeyboardFocused && getStateStyles(isSelected).focus,
  /* sc-selector */
  ListItemCheckbox, isSelected ? theme.color.state.primary.pressed.value : theme.color.state["default"].pressed.value, !showCheckbox && getStateStyles(isSelected).active);
}, function (_ref5) {
  var isDisabled = _ref5.isDisabled;
  return isDisabled && css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n      cursor: not-allowed;\n    "])));
});
var MenuListItem = /*#__PURE__*/React.forwardRef(function (_ref6, ref) {
  var children = _ref6.children,
      className = _ref6.className,
      customListItemTag = _ref6.customListItemTag,
      dataTestId = _ref6.dataTestId,
      graphicContent = _ref6.graphicContent,
      hideSelectedItemCheckmark = _ref6.hideSelectedItemCheckmark,
      indeterminate = _ref6.indeterminate,
      isDisabled = _ref6.isDisabled,
      isKeyboardFocused = _ref6.isKeyboardFocused,
      isSelected = _ref6.isSelected,
      onClick = _ref6.onClick,
      onSelect = _ref6.onSelect,
      showCheckbox = _ref6.showCheckbox,
      showDivider = _ref6.showDivider,
      tabIndex = _ref6.tabIndex;

  var handleClick = function handleClick() {
    onClick();

    if (onSelect) {
      onSelect(ref);
    }
  };

  return /*#__PURE__*/_jsxs(StyledListItem, {
    ref: ref,
    tabIndex: tabIndex,
    onClick: handleClick,
    isSelected: isSelected,
    isKeyboardFocused: isKeyboardFocused,
    isDisabled: isDisabled,
    customListItemTag: customListItemTag,
    className: className,
    showDivider: showDivider,
    showCheckbox: showCheckbox,
    hideStateVisibility: showCheckbox,
    "data-testid": dataTestId,
    children: [showCheckbox && /*#__PURE__*/_jsx(StyledListItemCheckbox, {
      "data-testid": dataTestId ? "".concat(dataTestId, "-checkbox") : undefined,
      indeterminate: indeterminate,
      checked: isSelected,
      isDisabled: isDisabled,
      isKeyboardFocused: isKeyboardFocused
    }), graphicContent && /*#__PURE__*/_jsx(ListItemGraphic, {
      "data-testid": dataTestId ? "".concat(dataTestId, "-graphic") : undefined,
      isDisabled: isDisabled,
      children: graphicContent
    }), /*#__PURE__*/_jsx(ListItemText, {
      "data-testid": dataTestId ? "".concat(dataTestId, "-text") : undefined,
      children: /*#__PURE__*/_jsx(StyledListItemPrimaryText, {
        "data-testid": dataTestId ? "".concat(dataTestId, "-primarytext") : undefined,
        isDisabled: isDisabled,
        children: children
      })
    }), isSelected && !showCheckbox && !hideSelectedItemCheckmark && /*#__PURE__*/_jsx(StyledIconCheck, {})]
  });
});
MenuListItem.propTypes = {
  /** Flag to show menu item as selected */
  isSelected: PropTypes.bool,

  /** Node/element to show inside menu item */
  children: PropTypes.node.isRequired,

  /** Adds new class to Menu */
  className: PropTypes.string,

  /** Callback function to trigger on click */
  onClick: PropTypes.func,

  /** Tab index attribute to enable keyboard focus */
  tabIndex: PropTypes.number,

  /** Flag to enable keyboard styles on menu items */
  isKeyboardFocused: PropTypes.bool,

  /** Disable filter to disable menu item */
  isDisabled: PropTypes.bool,

  /** Ability to supply a different element instead of the default one for ListItem element */
  customListItemTag: PropTypes.elementType,

  /** Accepts Avatar / Icon / Image inside menu item  */
  graphicContent: PropTypes.node,

  /** Enables Checkbox in menu item */
  showCheckbox: PropTypes.bool,

  /** Enables divider between menu items */
  showDivider: PropTypes.bool,

  /** Id value used for testing */
  dataTestId: PropTypes.string,

  /** Changes the icon and sets checkbox indeterminate parameter state */
  indeterminate: PropTypes.bool,

  /** callback function which triggers when selected is passed */
  onSelect: PropTypes.func,

  /** Hide selected Icon */
  hideSelectedItemCheckmark: PropTypes.bool
};
MenuListItem.defaultProps = {
  isSelected: false,
  className: '',
  onClick: undefined,
  tabIndex: 0,
  isKeyboardFocused: false,
  customListItemTag: undefined,
  graphicContent: undefined,
  showCheckbox: false,
  showDivider: false,
  dataTestId: '',
  indeterminate: false,
  onSelect: undefined,
  hideSelectedItemCheckmark: false
};
export { MenuListItem };